import * as React from 'react';
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {RouteComponentProps, withRouter} from "react-router";
import Routes from "../../../navigation/route/Route";

class BrandListEmptyView extends React.Component<RouteComponentProps<{}>, {}> {
	render() {
		return (
			<div className={"c-empty-view"}>
				<div className={"description"}>There is no brands yet.</div>
				<ButtonPrimary onClick={() => this.props.history.push(Routes.BrandCreate)}
							   label={"Create Brand"}
							   variant={"burgundy"}/>
			</div>
		);
	}
}

export default withRouter<{}>(BrandListEmptyView);
